import { connect } from 'react-redux';
import { getFrameDimensions } from '@marvelapp/core';
import BodyStyle from '../components/BodyStyle';
import { bodyNeedsDeviceHeight } from '../selectors/statusBar';
import { getFrame } from '../selectors/project';
function mapStateToProps(state) {
    var style = {};
    if (bodyNeedsDeviceHeight(state)) {
        var frame = getFrame(state);
        var height = getFrameDimensions(frame).height;
        style.height = height + "px";
    }
    return { style: style };
}
export default connect(mapStateToProps)(BodyStyle);
